import React from "react";
import FirstNails from "./components/nails/FirstNail";
import SecondNail from "./components/nails/SecondNails";
import ThirdNail from "./components/nails/ThirdNail";
import FourthNail from "./components/nails/FourNail";
import FifthNail from "./components/nails/Fifthnail";

const Nails = () => {
  return (
    <>
      <FirstNails />
      <SecondNail />
      <ThirdNail />
      <FourthNail />
      <FifthNail />
    </>
  );
};

export default Nails;
